/* FBM logo as inline SVG component. Fallback for when the PNG asset isn't reachable. */
export default function FbmLogo({ size = 36, withText = true, theme = "dark", className = "" }) {
  const fg = theme === "dark" ? "#d6ff00" : "#0a1410";
  const bg = theme === "dark" ? "#0a1410" : "#d6ff00";
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} aria-label="FBM logo">
      <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true">
        <rect width="64" height="64" rx="8" fill={bg} />
        <path d="M14 50 L14 14 L34 14 L34 22 L22 22 L22 28 L32 28 L32 36 L22 36 L22 50 Z" fill={fg} />
        <path d="M36 50 L36 14 L46 14 L50 30 L50 14 L58 14 L58 50 L48 50 L44 34 L44 50 Z" fill={fg} opacity="0.95" />
        <circle cx="50" cy="50" r="4" fill={fg} />
      </svg>
      {withText && (
        <span className="leading-tight">
          <span className="block font-display uppercase tracking-[0.18em] text-[10px] opacity-70">Football Behavior</span>
          <span className="block font-display uppercase tracking-tight text-lg leading-none">Management</span>
        </span>
      )}
    </span>
  );
}
